import React, { useMemo, useState } from 'react';
import { Box, Button, IconButton, Tooltip } from '@mui/material';
import {
  getProfileSectionIcon,
  PRIMARY_PROFILE_SECTION_ICON_KEYS,
  PROFILE_SECTION_ICON_OPTIONS,
} from '../CompanyProfile/sections/profileSectionIcons';

const IconPicker = ({ value, onChange }) => {
  const [showMore, setShowMore] = useState(
    Boolean(value) && !PRIMARY_PROFILE_SECTION_ICON_KEYS.includes(value),
  );

  const visibleOptions = useMemo(() => {
    if (showMore) return PROFILE_SECTION_ICON_OPTIONS;
    return PROFILE_SECTION_ICON_OPTIONS.filter((item) =>
      PRIMARY_PROFILE_SECTION_ICON_KEYS.includes(item.key),
    );
  }, [showMore]);

  return (
    <Box>
      <Box display='flex' flexWrap='wrap' gap={1} alignItems='center'>
        {visibleOptions.map((option) => {
          const Icon = getProfileSectionIcon(option.key);
          const selected = value === option.key;
          return (
            <Tooltip key={option.key} title={option.label} arrow>
              <IconButton
                onClick={() => onChange(option.key)}
                aria-label={option.label}
                sx={{
                  width: 40,
                  height: 40,
                  border: 1,
                  borderColor: selected ? 'primary.main' : 'divider',
                  bgcolor: selected ? 'rgba(25, 118, 210, 0.08)' : '#fff',
                  color: selected ? 'primary.main' : 'text.secondary',
                  borderRadius: 1.5,
                }}
              >
                <Icon sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>
          );
        })}
        <Button
          size='small'
          onClick={() => setShowMore((current) => !current)}
          sx={{ textTransform: 'none', minWidth: 0, px: 1.25 }}
        >
          {showMore ? 'Less' : '+ More'}
        </Button>
      </Box>
    </Box>
  );
};

export default IconPicker;
